import { create } from 'zustand';

import { SettingsTab } from '@/types';

import { VerifiedTransfer } from './use-transfers-store';

interface ModalStore {
  verifiedTransfer: VerifiedTransfer | undefined;
  setVerifiedTransfer: (transfer: VerifiedTransfer) => void;
  isAccountModalOpen: boolean;
  isLeverageModalOpen: boolean;
  isGuideModalOpen: boolean;
  isSwitchModalOpen: boolean;
  isWithdrawConfirmationModalOpen: boolean;
  handledVerifiedTransferID: string | undefined;
  setHandledVerifiedTransferID: (id: string) => void;
  isCapitalResultModalOpen: boolean;
  isCapitalTourStartModalOpen: boolean;
  isCapitalTourEndModalOpen: boolean;
  isDiscountsModalOpen: boolean;
  isCapitalTourOpen: boolean;
  activeSettingsTab: SettingsTab | null;
  isReferralLinkModalOpen: boolean;
}

export const useModalStore = create<ModalStore>((set, _get) => ({
  activeSettingsTab: null,
  verifiedTransfer: undefined,
  setVerifiedTransfer: (transfer) => set({ verifiedTransfer: transfer }),
  handledVerifiedTransferID: undefined,
  setHandledVerifiedTransferID: (id) => set({ handledVerifiedTransferID: id }),
  isGuideModalOpen: false,
  isAccountModalOpen: false,
  isLeverageModalOpen: false,
  isSwitchModalOpen: false,
  isWithdrawConfirmationModalOpen: false,
  isCapitalResultModalOpen: false,
  isCapitalTourStartModalOpen: false,
  isCapitalTourEndModalOpen: false,
  isDiscountsModalOpen: false,
  isCapitalTourOpen: false,
  isReferralLinkModalOpen: false,
}));
